// 萤石云监控配置（accessToken 需要从 Redux 获取，不在此处硬编码）
export const EZVIZ_CONFIG = {
  appKey: process.env.REACT_APP_EZVIZ_APP_KEY || 'caa6c40ed709485497f0a9ee4951794a',
  // accessToken 已移除，改为从 Redux state.app.ys7Token 获取
  secret: process.env.REACT_APP_EZVIZ_SECRET || 'eed4fe8107b0ca743aa13866970e25a6',
  deviceSerial: 'BG9235983',
  channelNo: 1,
  // HLS 配置
  protocol: 'hls', // 'ezopen' | 'hls' | 'rtmp'
  hlsUrl: 'https://www.duobaby.net/hls/ipc.m3u8'
};

// 错误码映射
export const ERROR_MESSAGES = {
  5: '设备密码错误，请检查设备配置',
  4004: '设备不在线',
  4005: '设备不支持该功能',
  4006: '设备已下线',
  default: '视频播放失败，请稍后重试'
};

// 播放器默认配置
export const PLAYER_CONFIG = {
  width: 960,
  height: 540,
  autoplay: true
};

export const POINTS = [
  {name: '点-0', coord: [113.2645, 23.1301], value: 30 },
  {name: '点-1', coord: [113.2145, 23.1158], value: 30 },
  {name: '点-2', coord: [113.2957, 23.0690], value: 30 },
  {name: '点-3', coord: [113.2304, 23.1333], value: 30 },
  {name: '点-4', coord: [113.2505, 23.1223], value: 30 },
  {name: '点-5', coord: [113.2473, 23.1229], value: 30 },
  {name: '点-6', coord: [113.2620, 23.1232], value: 30 },
  {name: '点-7', coord: [113.2532, 23.1208], value: 30 },
  {name: '点-8', coord: [113.3334, 23.0870], value: 30 },
  {name: '点-9', coord: [113.2614, 23.1206], value: 30 },
  {name: '点-10', coord: [113.2833, 23.1074], value: 30 },
  {name: '点-11', coord: [113.2618, 23.1527], value: 30 },
  {name: '点-12', coord: [113.3075, 23.1261], value: 30 },
  {name: '点-13', coord: [113.2523, 23.1652], value: 30 },
  {name: '点-14', coord: [113.2539, 23.1288], value: 30 },
  {name: '点-15', coord: [113.2615, 23.1332], value: 30 },
  {name: '点-16', coord: [113.2480, 23.1307], value: 30 },
  {name: '点-17', coord: [113.2534, 23.1263], value: 30 },
  {name: '点-18', coord: [113.2661, 23.2098], value: 30 },
  {name: '点-19', coord: [113.2503, 23.1226], value: 30 },
  {name: '点-20', coord: [113.2424, 23.1253], value: 30 },
  {name: '点-21', coord: [113.2414, 23.1366], value: 30 },
  {name: '点-22', coord: [113.2645, 23.1301], value: 30 },
  {name: '点-23', coord: [113.2863, 23.1177], value: 30 },
  {name: '点-24', coord: [113.2545, 23.1279], value: 30 },
  {name: '点-25', coord: [113.2557, 23.1590], value: 30 },
  {name: '点-26', coord: [113.2477, 23.1335], value: 30 },
  {name: '点-27', coord: [113.2528, 23.1182], value: 30 },
  {name: '点-28', coord: [113.2455, 23.1236], value: 30 },
  {name: '点-29', coord: [113.2559, 23.1737], value: 30 },
  {name: '点-30', coord: [113.3193, 23.1292], value: 30 },
  {name: '点-31', coord: [113.2898, 23.0276], value: 30 },
  {name: '点-32', coord: [113.2488, 23.1259], value: 30 },
  {name: '点-33', coord: [113.2493, 23.1256], value: 30 },
  {name: '点-34', coord: [113.2369, 23.1167], value: 30 },
  {name: '点-35', coord: [113.2274, 23.1432], value: 30 },
  {name: '点-36', coord: [113.2438, 23.1297], value: 30 },
  {name: '点-37', coord: [113.2356, 23.1147], value: 30 },
  {name: '点-38', coord: [113.3384, 23.1142], value: 30 },
  {name: '点-39', coord: [113.2411, 23.2098], value: 30 },
  {name: '点-40', coord: [113.2274, 23.1432], value: 30 },
  {name: '点-41', coord: [113.2575, 23.1252], value: 30 },
  {name: '点-42', coord: [113.2331, 23.1491], value: 30 },
  {name: '点-43', coord: [113.2853, 23.1177], value: 30 },
  {name: '点-44', coord: [113.3028, 23.1563], value: 30 },
  {name: '点-45', coord: [113.2069, 23.2483], value: 30 },
  {name: '点-46', coord: [113.2552, 23.1298], value: 30 },
  {name: '点-47', coord: [113.2548, 23.1765], value: 30 },
  {name: '点-48', coord: [113.2697, 23.1022], value: 30 },
  {name: '点-49', coord: [113.2645, 23.1301], value: 30 },
  {name: '点-50', coord: [113.2287, 23.1331], value: 30 },
  {name: '点-51', coord: [113.2610, 23.1199], value: 30 },
  {name: '点-52', coord: [113.2936, 23.0733], value: 30 },
  {name: '点-53', coord: [113.2517, 23.1123], value: 30 },
  {name: '点-54', coord: [113.8437, 23.3363], value: 30 },
  {name: '点-55', coord: [113.2510, 23.2293], value: 30 },
  {name: '点-56', coord: [113.2725, 23.1987], value: 30 },
  {name: '点-57', coord: [113.2775, 23.1653], value: 30 },
  {name: '点-58', coord: [113.2705, 23.1654], value: 30 },
  {name: '点-59', coord: [113.3001, 23.0813], value: 30 },
  {name: '点-60', coord: [113.2137, 23.0574], value: 30 },
  {name: '点-61', coord: [113.2345, 23.1375], value: 30 },
  {name: '点-62', coord: [113.3018, 23.1420], value: 30 },
  {name: '点-63', coord: [113.2400, 23.1557], value: 30 },
  {name: '点-64', coord: [113.2348, 23.1340], value: 30 },
  {name: '点-65', coord: [113.2831, 23.1158], value: 30 },
  {name: '点-66', coord: [113.2667, 23.0870], value: 30 },
  {name: '点-67', coord: [113.2414, 23.1439], value: 30 },
  {name: '点-68', coord: [113.2422, 23.1765], value: 30 },
  {name: '点-69', coord: [113.2240, 23.1311], value: 30 },
  {name: '点-70', coord: [113.2510, 23.2293], value: 30 },
  {name: '点-71', coord: [113.2645, 23.1301], value: 30 },
  {name: '点-72', coord: [113.2445, 23.2102], value: 30 },
  {name: '点-73', coord: [113.4028, 23.0375], value: 30 },
  {name: '点-74', coord: [113.2626, 23.1229], value: 30 },
  {name: '点-75', coord: [113.2558, 23.1257], value: 30 },
  {name: '点-76', coord: [113.2626, 23.1229], value: 30 },
  {name: '点-77', coord: [113.2669, 23.0935], value: 30 },
  {name: '点-78', coord: [113.2498, 23.1947], value: 30 },
  {name: '点-79', coord: [113.3032, 23.0651], value: 30 },
  {name: '点-80', coord: [113.3347, 23.0409], value: 30 },
  {name: '点-81', coord: [113.2544, 23.1274], value: 30 },
  {name: '点-82', coord: [113.2463, 23.1312], value: 30 },
  // {name: '点-83', coord: [113.2645, 23.1301], value: 30 },
  // {name: '点-84', coord: [113.2452, 23.1349], value: 30 },
  // {name: '点-85', coord: [113.2743, 23.1771], value: 30 },
  // {name: '点-86', coord: [113.2575, 23.1252], value: 30 },
  // {name: '点-87', coord: [113.2300, 23.0927], value: 30 },
  // {name: '点-88', coord: [113.2575, 23.0857], value: 30 },
  // {name: '点-89', coord: [113.2363, 23.1612], value: 30 },
  // {name: '点-90', coord: [113.3351, 23.1266], value: 30 },
  // {name: '点-91', coord: [113.2769, 23.1757], value: 30 },
  // {name: '点-92', coord: [113.2142, 23.3312], value: 30 },
  // {name: '点-93', coord: [113.2498, 23.1268], value: 30 },
  // {name: '点-94', coord: [113.2645, 23.1301], value: 30 },
  // {name: '点-95', coord: [113.2473, 23.1229], value: 30 },
  // {name: '点-96', coord: [113.3647, 22.9213], value: 30 },
  // {name: '点-97', coord: [113.2645, 23.1301], value: 30 },
  // {name: '点-98', coord: [113.2514, 23.1779], value: 30 },
  // {name: '点-99', coord: [113.2566, 23.1872], value: 30 },
  // {name: '点-100', coord: [113.2456, 23.1499], value: 30 },
  // {name: '点-101', coord: [113.2041, 23.2074], value: 30 },
  // {name: '点-102', coord: [113.2543, 23.1217], value: 30 },
  // {name: '点-103', coord: [113.3328, 23.1542], value: 30 },
  // {name: '点-104', coord: [113.2438, 23.1306], value: 30 },
  // {name: '点-105', coord: [113.3373, 22.8234], value: 30 },
  // {name: '点-106', coord: [113.2287, 23.1331], value: 30 },
  // {name: '点-107', coord: [113.2343, 23.1096], value: 30 },
  // {name: '点-108', coord: [113.2254, 23.0767], value: 30 },
  // {name: '点-109', coord: [113.2331, 23.1491], value: 30 },
  // {name: '点-110', coord: [113.2429, 23.2044], value: 30 },
  // {name: '点-111', coord: [113.3001, 23.0916], value: 30 },
  // {name: '点-112', coord: [113.2094, 23.1974], value: 30 },
  // {name: '点-113', coord: [113.2413, 23.1212], value: 30 },
  // {name: '点-114', coord: [113.2128, 23.1136], value: 30 },
  // {name: '点-115', coord: [113.3458, 23.0316], value: 30 },
  // {name: '点-116', coord: [113.2386, 23.1215], value: 30 },
  // {name: '点-117', coord: [113.2412, 23.1184], value: 30 },
  // {name: '点-118', coord: [113.2965, 23.0887], value: 30 },
  // {name: '点-119', coord: [113.2386, 23.1166], value: 30 },
  // {name: '点-120', coord: [113.2226, 23.1270], value: 30 },
  // {name: '点-121', coord: [113.2505, 23.1278], value: 30 },
  // {name: '点-122', coord: [113.2451, 23.0880], value: 30 },
  // {name: '点-123', coord: [113.2470, 23.1148], value: 30 },
  // {name: '点-124', coord: [113.2519, 23.1239], value: 30 },
  // {name: '点-125', coord: [113.2304, 23.1333], value: 30 },
  // {name: '点-126', coord: [113.2395, 23.1199], value: 30 },
  // {name: '点-127', coord: [113.3318, 23.1279], value: 30 },
  // {name: '点-128', coord: [113.2150, 23.1321], value: 30 },
  // {name: '点-129', coord: [113.2426, 23.0740], value: 30 },
  // {name: '点-130', coord: [113.2385, 23.1086], value: 30 },
  // {name: '点-131', coord: [113.2415, 23.1080], value: 30 },
  // {name: '点-132', coord: [113.2434, 23.1168], value: 30 },
  // {name: '点-133', coord: [113.2412, 23.1273], value: 30 },
  // {name: '点-134', coord: [113.3001, 23.0770], value: 30 },
  // {name: '点-135', coord: [113.2369, 23.0815], value: 30 },
  // {name: '点-136', coord: [113.2374, 23.1385], value: 30 },
  // {name: '点-137', coord: [113.2321, 23.0808], value: 30 },
  // {name: '点-138', coord: [113.5042, 23.0858], value: 30 },
  // {name: '点-139', coord: [113.2786, 23.1246], value: 30 },
  // {name: '点-140', coord: [112.8962, 9.5485], value: 30 },
  // {name: '点-141', coord: [113.3308, 23.0930], value: 30 },
  // {name: '点-142', coord: [113.2392, 23.1254], value: 30 },
  // {name: '点-143', coord: [113.2570, 23.1311], value: 30 },
  // {name: '点-144', coord: [113.2395, 23.1266], value: 30 },
  // {name: '点-145', coord: [113.2645, 23.1301], value: 30 },
  // {name: '点-146', coord: [113.2287, 23.1331], value: 30 },
  // {name: '点-147', coord: [113.2445, 23.1081], value: 30 },
  // {name: '点-148', coord: [113.2343, 23.1626], value: 30 },
  // {name: '点-149', coord: [113.2416, 23.1206], value: 30 },
  // {name: '点-150', coord: [113.2533, 23.1404], value: 30 },
  // {name: '点-151', coord: [113.2514, 23.1329], value: 30 },
  // {name: '点-152', coord: [113.3464, 22.9951], value: 30 },
  // {name: '点-153', coord: [113.2467, 23.1236], value: 30 },
  // {name: '点-154', coord: [113.2358, 23.1232], value: 30 },
  // {name: '点-155', coord: [113.2479, 23.1201], value: 30 },
  // {name: '点-156', coord: [113.2566, 23.1276], value: 30 },
  // {name: '点-157', coord: [113.2797, 23.0767], value: 30 },
  // {name: '点-158', coord: [113.2569, 23.1234], value: 30 },
  // {name: '点-159', coord: [113.2553, 23.1289], value: 30 },
  // {name: '点-160', coord: [113.2707, 23.1766], value: 30 },
  // {name: '点-161', coord: [113.2385, 23.0686], value: 30 },
  // {name: '点-162', coord: [113.2968, 23.0659], value: 30 },
  // {name: '点-163', coord: [113.2669, 23.0935], value: 30 },
  // {name: '点-164', coord: [113.2410, 23.0825], value: 30 },
  // {name: '点-165', coord: [113.2207, 23.1582], value: 30 },
  // {name: '点-166', coord: [113.2391, 23.0670], value: 30 },
  // {name: '点-167', coord: [113.2374, 23.1278], value: 30 },
  // {name: '点-168', coord: [113.3230, 23.1301], value: 30 },
  // {name: '点-169', coord: [113.2537, 23.1215], value: 30 },
  // {name: '点-170', coord: [113.2446, 23.0710], value: 30 },
  // {name: '点-171', coord: [113.2853, 23.1414], value: 30 },
  // {name: '点-172', coord: [113.2211, 23.1785], value: 30 },
  // {name: '点-173', coord: [113.3285, 23.0988], value: 30 },
  // {name: '点-174', coord: [113.2901, 23.1283], value: 30 },
  // {name: '点-175', coord: [113.2437, 23.1341], value: 30 },
  // {name: '点-176', coord: [113.2574, 23.1692], value: 30 },
  // {name: '点-177', coord: [113.2101, 23.1458], value: 30 },
  // {name: '点-178', coord: [113.2536, 23.1276], value: 30 },
  // {name: '点-179', coord: [113.2554, 23.1238], value: 30 },
  // {name: '点-180', coord: [113.2752, 23.1663], value: 30 },
  // {name: '点-181', coord: [113.2413, 23.1594], value: 30 },
  // {name: '点-182', coord: [113.2574, 23.3861], value: 30 },
  // {name: '点-183', coord: [113.2800, 23.1202], value: 30 },
  // {name: '点-184', coord: [113.2851, 23.1043], value: 30 },
  // {name: '点-185', coord: [113.1885, 23.0711], value: 30 },
  // {name: '点-186', coord: [113.2603, 23.1179], value: 30 },
  // {name: '点-187', coord: [113.4899, 23.1724], value: 30 },
  // {name: '点-188', coord: [113.2391, 23.0670], value: 30 }
]